import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Route, Switch } from 'react-router';

import MealsTypesFooter from 'PointOfSale/modules/layouts/container/MealsTypesFooter';
import PaymentOptionsContainer from 'PointOfSale/modules/layouts/container/PaymentOptionsContainer';
import ServingOptionFooter from 'PointOfSale/modules/layouts/container/ServingOptionFooter';
import GroupProfileFooterContainer from 'PointOfSale/modules/layouts/container/GroupProfileFooterContainer';
import GroupFooterContainer from 'PointOfSale/modules/layouts/container/GroupFooterContainer';
import TeacherFooterContainer from 'PointOfSale/modules/layouts/container/TeacherFooterContainer';
import MealCounterFooter from 'PointOfSale/modules/layouts/container/MealCounterFooter';
import { HistoryFooter } from './HistoryFooter';

import { POS_ROUTES } from 'PointOfSale/modules/common/constants';

import 'PointOfSale/styles/components/pageFooter.less';

const PageFooter = () => {
  return (
    <Grid padded className="page-footer-margin">
      <Grid.Column mobile={4} largeScreen={3}>
        <HistoryFooter />
      </Grid.Column>
      <Grid.Column width={12} floated={'right'}>
        <Grid className="footer-menu-padding">
          <Switch>
            <Route
              path={POS_ROUTES.MEAL_COUNTER}
              component={MealCounterFooter}
            />
            <Route
              path={POS_ROUTES.SERVE_OPTIONS}
              component={ServingOptionFooter}
            />
            <Route
              path={POS_ROUTES.QUEUE_INDIVIDUAL}
              component={PaymentOptionsContainer}
            />
            <Route path={POS_ROUTES.QUEUE} component={null} />
            <Route
              exact
              path={POS_ROUTES.GROUP}
              component={GroupFooterContainer}
            />
            <Route
              exact
              path={POS_ROUTES.GROUP_INDIVIDUAL}
              component={GroupProfileFooterContainer}
            />
            <Route
              exact
              path={POS_ROUTES.TEACHER}
              component={TeacherFooterContainer}
            />
            <Route
              exact
              path={POS_ROUTES.TEACHER_INDIVIDUAL}
              component={PaymentOptionsContainer}
            />
            <Route path={POS_ROUTES.HOME} component={MealsTypesFooter} />
          </Switch>
        </Grid>
      </Grid.Column>
    </Grid>
  );
};

export default PageFooter;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/PageFooter.js